import { createRoot } from 'react-dom/client';
import InsightsListingMain from './InsightsListingMain';

const rootElement = document.getElementById('skill-insights-listing-root');

if (rootElement) {
  const root = createRoot(rootElement);
  const numberToShow = rootElement.getAttribute('data-number-to-show') || '15';
  const baseUrl = rootElement.getAttribute('data-base-url') || '/insights/';

  root.render(
    <InsightsListingMain numberToShow={numberToShow} baseUrl={baseUrl} />,
  );
}
